// extracted by mini-css-extract-plugin
export default {"category-carousel":"_7ai3y3","categoryCarousel":"_7ai3y3","category-card":"_eowq3","categoryCard":"_eowq3","link":"_1r5eo9a"};